// Module
var code = "<div class=\"field\">\r\n  <label class=\"label\"></label>\r\n  <div class=\"control\">\r\n    <% _(selectOptions).each(function(option) { %>\r\n    <label class=\"radio\">\r\n      <input type=\"radio\" name=\"<%= name %>\" value=\"<%= option.value %>\">\r\n      <%= option.label %>\r\n    </label>\r\n    <% }) %>\r\n  </div>\r\n</div>\r\n";
// Exports
module.exports = code;